import { useQuery } from '@tanstack/react-query'

import { getPLPBasicMetas } from './get-plp-basic-metas'

import { usePLPFacetsContext } from '../facets-context/facets-context'
import { PLPBasicMetasProps, PLPPages, PLPReactQueryKeys } from '../types'

interface UseBasicMetasProps {
    basicMetas?: PLPBasicMetasProps
    isLoadingBasicMetas: boolean
}

export function useBasicMetas(): UseBasicMetasProps {
    const { page, slug } = usePLPFacetsContext()
    // reason of getting 404 error - not use queryClient.getQueryData because it's not set as an observer and garbage collecting data after passing a time
    const {
        data: basicMetas,
        isRefetching,
        isLoading,
    } = useQuery<PLPBasicMetasProps>({
        queryKey: [PLPReactQueryKeys.BasicMeta, { page, slug }],
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        queryFn: () => getPLPBasicMetas(page!, slug!),
        enabled: page !== PLPPages.Search && !!page && !!slug,
        staleTime: Infinity,
        refetchOnMount: false,
    })

    if (page === PLPPages.Search) return { basicMetas: undefined, isLoadingBasicMetas: false }

    return { basicMetas, isLoadingBasicMetas: isLoading || isRefetching }
}
